import { toPercent } from './format'

export function topConfidencePercent(confidenceMap: Record<string, number>): number | null {
  const values = Object.values(confidenceMap)
  if (!values.length) return null
  return toPercent(Math.max(...values))
}
